import { ConnectedInputField } from '../../Shared/ConnectedInputField';
import { ESP_ACCOUNT_PAYLOAD_FIELDS } from '../../../../types';
import { CreateModalRHF } from '../../Shared/CreateModalRHF';
import { useCreateAccount } from '../../../../hooks';

const { NAME, API_KEY, API_ENDPOINT } = ESP_ACCOUNT_PAYLOAD_FIELDS;

export const TwilioCreateModal = () => {
  const { createAccount } = useCreateAccount();
  return (
    <CreateModalRHF headerText="Connect Twilio account" onSubmit={createAccount}>
      <ConnectedInputField
        name={NAME}
        labelText="API key SID"
        placeholder="SKxxxxxxxxxxxxxxxx"
        data-test="name-input"
      />
      <ConnectedInputField name={API_KEY} labelText="API key secret" data-test="apiKey-input" />
      <ConnectedInputField
        name={API_ENDPOINT}
        labelText="Account SID"
        placeholder="ACxxxxxxxxxxxxxxxx"
        data-test="apiEndpoint-input"
      />
    </CreateModalRHF>
  );
};
